$ = require 'jquery'
Dates = require 'lib/dates'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'

module.exports = class SessionView extends View
  className: 'member-account-session'

  events:
    'click .js-revoke': 'revoke'

  render: ->
    data = @options
    data["type_#{ @options.type }"] = true

    { ipAddress } = data

    @$el.html(templates.fill('member_session', data))

    Dates.update(@el)

    @

  revoke: (e) ->
    $.get "/login/revoke", { id: @options.id }, =>
      @model.set "sessions", _.filter @model.get('sessions'), (session) => session.id != @options.id



// WEBPACK FOOTER //
// ./app/scripts/views/member/session-view.coffee